import API from './axios.js';

export const searchParties = (name,input) =>API.get(`case/by-name/${name}?search=${input}&limit=1000000`);



export const searchExpenses = (input) =>API.get(`expense?search=${input}`);

export const searchNote = (input) =>API.get(`note?search=${input}`);


export const searchTasksByMe = (input) =>API.get(`task/assigned-by-user?search=${input}`);
export const searchTasksToMe = (input) =>API.get(`task?search=${input}`);

export const searchLabel = (input) =>API.get(`label?search=${input}`);

export const searchMyClient = (input) =>API.get(`clients?search=${input}`);

export const searchAddedUsers = (input) =>API.get(`auth/hierarchy?search=${input}`);

export const InvoiceForCompany = (input) =>API.get(`invoice/created-by-company?search=${input}`);
export const InvoiceForClient = (input) =>API.get(`invoice/created-for-customer?search=${input}`);




export const searchDistrictCaseManual = (input) =>API.get(`case/district-court/manual?search=${input}&limit=1000000`);
export const searchDistrictCaseFetched = (input) =>API.get(`case/district-court/by-company?search=${input}&limit=1000000`);
export const searchHighCaseManual = (input) =>API.get(`case/manual?search=${input}&limit=1000000`);
export const searchHighCaseFetched = (input) =>API.get(`case/by-company?search=${input}&limit=1000000`);
export const searchOtherCourtCases = (input) =>API.get(`case/other-court?search=${input}&limit=1000000`);
export const searchSupremeCourtCaseFetched = (input) =>API.get(`case/supreme-court/by-company?search=${input}&limit=1000000`);
export const searchSupremeCourtCaseManual = (input) =>API.get(`case/supreme-court/manual?search=${input}&limit=1000000`);